import BookingFlowPage from './BookingFlowPage';

/** @deprecated Use BookingFlowPage — kept for route compatibility */
const BookingPage = () => <BookingFlowPage entryMode="location" variant="page" />;

export default BookingPage;
